module.exports = __webpack_public_path__ + "img/vertical_3_3_8023.ba784435.png";